import ExecuteScript from './ExecuteScript/ExecuteScript';
import Open from './Open/Open';
import { types } from './types';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Actions(action, showAlert, variables, setOpenVariable, recorder, setRender) {
    switch (action.actionName) {
        case types.EXECUTE: return <ExecuteScript action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} recorder={recorder} setRender={setRender}/>;
        case types.OPEN: return <Open action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} recorder={recorder} setRender={setRender}/>;
        default: break;
    }
}
export default Actions;